import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import {
  Feature,
  PricingClient,
  VelocityCircuitBreakerSuppressionType,
} from 'src/WebApiController';

import { useUserHasFeature } from '../useUserHasFeature';

export const useSuppressCircuitBreakerActions = () => {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();
  const queryClient = useQueryClient();

  const hasIgnoreVeloCbFeature = useUserHasFeature(
    Feature.AutoPricingIgnoreVeloCB
  );

  const suppressVelocityCircuitBreakerMutation = useMutation({
    mutationFn: async ({
      listingId,
      suppressionType,
    }: {
      listingId: number;
      suppressionType: VelocityCircuitBreakerSuppressionType;
    }) => {
      if (!hasIgnoreVeloCbFeature) {
        return;
      }

      const client = new PricingClient(activeAccountWebClientConfig);
      return await client.suppressVelocityCircuitBreaker(
        listingId,
        suppressionType
      );
    },
    onSuccess: (data, { listingId }) => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === 'ListingClient.getListingPriceCalculation' &&
          (query.queryKey[1] as any)?.listingId === listingId,
      });
    },
    onError: (err: ErrorTypes, { listingId }, context) => {
      showErrorDialog('PricingClient.suppressVelocityCircuitBreaker', err, {
        trackErrorData: { listingId },
      });
    },
  });

  return {
    onSubmit: suppressVelocityCircuitBreakerMutation.mutate,
  };
};
